<template>
  <modal-vue @close="handleClose" :modalActive="show" :hasFooterBorder="true" isFilterModal>
    <template #header>
      <p class="font-bold">{{ title }}</p>
    </template>
    <v-row no-gutters>
      <v-col>
        <v-icon color="warning" size="100" :icon="mdiAlert" />
      </v-col>
      <v-col cols="12">
        <p class="text-center" :class="showJustification ? 'mb-4' : ''">
          {{ description }}
        </p>
      </v-col>
      <v-col v-if="showJustification" cols="12">
        <v-textarea
          v-model="justification"
          :label="'* ' + justificationLabel"
          variant="outlined"
          rows="3"
          auto-grow
          :error-messages="showError ? 'Justificativa é obrigatória' : []"
          @update:modelValue="showError = false"
        />
      </v-col>
    </v-row>
    <template #footer>
      <v-row class="pt-4">
        <v-col cols="12" md="6">
          <filled-button
            data-testid="confirm-action-cancel-button"
            @click="handleClose"
            width="100%"
            text="Cancelar"
          />
        </v-col>
        <v-col cols="12" md="6">
          <outline-button
            data-testid="confirm-action-confirm-button"
            :loading="isLoading"
            @click="handleConfirm"
            :text="textButton"
            height="52px"
            width="100%"
            color="primary"
          />
        </v-col>
      </v-row>
    </template>
  </modal-vue>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { mdiAlert } from '@mdi/js'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Atenção, confirme a exclusão'
  },
  description: {
    type: String,
    default: 'Você tem certeza que deseja excluir esse registro?'
  },
  textButton: {
    type: String,
    default: 'Deletar'
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  showJustification: {
    type: Boolean,
    default: false
  },
  justificationLabel: {
    type: String,
    default: 'Justificativa'
  }
})

const emit = defineEmits<{
  (e: 'closeModal'): void
  (e: 'handleConfirm', justification?: string): void
}>()

const justification = ref('')
const showError = ref(false)

function handleConfirm() {
  if (props.showJustification && !justification.value.trim()) {
    showError.value = true
    return
  }
  emit('handleConfirm', props.showJustification ? justification.value.trim() : undefined)
}

function handleClose() {
  justification.value = ''
  showError.value = false
  emit('closeModal')
}
</script>
